<script setup>
import {defineProps, computed} from 'vue'

const AUDIENCES = {
  'super-admin': {icon: 'fa-user-shield', label: 'Super Admin only'},
  support: {icon: 'fa-headset', label: 'Tech Support only'},
}

const props = defineProps({
  audience: {
    type: String,
    required: true,
    validator: value => ['super-admin', 'support'].includes(value),
  },
})

const audienceInfo = computed(() => AUDIENCES[props.audience])
</script>

<template>
  <i
    :class="['restricted-access-mark fa-light ms-1', audienceInfo.icon]"
    :aria-label="audienceInfo.label"
    v-tooltip="audienceInfo.label"
  ></i>
</template>

<style lang="scss" scoped>
.restricted-access-mark {
  font-size: toRem(12);
  color: $text-muted;
  cursor: help;
}
</style>
